import { getImageSizeUrl } from "@/utils/getImageSizeUrl";
import type { Infer } from "superstruct";

import type { RewardsIconSizeEntity } from "../entities/entities";
import { RewardsProductSchema } from "../schemas/RewardsFreeProductSchemas/RewardsFreeProductSchema";

export const getRewardsImageUrl = (
    icons?: Array<RewardsIconSizeEntity>,
    size?: string,
    products?: Array<Infer<typeof RewardsProductSchema>>
): string | null | undefined => {
    if (products?.length) return products[0].image;

    if (icons?.length && size) return getImageSizeUrl(icons, size);
};
